import phoneMask from '@mobi/utils/masks/phone'
import cpfMask from '@mobi/utils/masks/cpf'
import cnpjMask from '@mobi/utils/masks/cnpj'
import dateMask from '@mobi/utils/masks/date'

const getMask = (maskName = '') => {
  const masksMaps = {
    phone: phoneMask,
    cpf: cpfMask,
    cnpj: cnpjMask,
    date: dateMask,
  }
  return masksMaps[maskName] || false
}

export default getMask
